// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CommitteeMember } from './committee-member';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Committee extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Committees = {
        FullCouncil: 1,
        Deacons: 2,
        ShepherdingElders: 3,
        ExecutiveElders: 4,
        ExecutiveCommittee: 5,
        Finance: 9,
    };
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  isVisible!: boolean;
  name?: string;
  usesDocumentStorage!: boolean;
  committeeMembers!: CommitteeMember[];
}

